export { default } from './CookieBanner';
